import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonComponent, IconButtonComponent } from './components';

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonComponent, IconButtonComponent],
  exports: [ButtonComponent, IconButtonComponent],
})
export class ButtonModule {}
